// @internal
import React from 'react';
import { IconProps } from '../../../Icon/Icon';
import Bubble, { BubbleProps } from '../../../Bubble/Bubble';
import { StyledSideNavGroupItemLabel } from './styles';

import { StyledSideNavBubbleWrapper } from '../SideNavItem/styles';

type InternalSideNavGroupItemContentProps = {
  title: string;
  isClosed: boolean;
  imageIcon?: IconProps['type'] | null;
  bubble?: { type?: BubbleProps['type']; text: string | number } | null;
  openInNewTab?: boolean;
  'data-testid'?: string | number;
};

export const SideNavGroupItemContent = (props: InternalSideNavGroupItemContentProps) => {
  const { bubble, isClosed, title, 'data-testid': dataTestId } = props;
  return (
    <>
      <StyledSideNavGroupItemLabel isClosed={isClosed} data-testid={dataTestId ? `${dataTestId}-content-label` : ''}>
        {title}
      </StyledSideNavGroupItemLabel>
      {bubble && (
        <StyledSideNavBubbleWrapper isClosed={isClosed}>
          <Bubble type={bubble.type || 'orange'}>{bubble.text}</Bubble>
        </StyledSideNavBubbleWrapper>
      )}
    </>
  );
};
